var _mask, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "hole_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 301,
    height: 88
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.5,
    cy: 44,
    rx: 150.229,
    ry: 44,
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hole_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.5,
    cy: 44,
    rx: 150.229,
    ry: 44,
    fill: "url(#hole_svg__paint0_linear)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.5,
    cy: 92,
    rx: 150.5,
    ry: 44,
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hole_svg__paint0_linear",
    x1: 295.5,
    y1: 49.5,
    x2: 28,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9Ijg4IiB2aWV3Qm94PSIwIDAgMzAxIDg4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8bWFzayBpZD0ibWFzazAiIG1hc2stdHlwZT0iYWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIzMDEiIGhlaWdodD0iODgiPgo8ZWxsaXBzZSBjeD0iMTUwLjUiIGN5PSI0NCIgcng9IjE1MC4yMjkiIHJ5PSI0NCIgZmlsbD0iYmxhY2siLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CjxlbGxpcHNlIGN4PSIxNTAuNSIgY3k9IjQ0IiByeD0iMTUwLjIyOSIgcnk9IjQ0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxlbGxpcHNlIGN4PSIxNTAuNSIgY3k9IjkyIiByeD0iMTUwLjUiIHJ5PSI0NCIgZmlsbD0iYmxhY2siLz4KPC9nPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyIiB4MT0iMjk1LjUiIHkxPSI0OS41IiB4Mj0iMjgiIHkyPSI0My45OTk5IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiMyMjIyMjIiLz4KPHN0b3Agb2Zmc2V0PSIwLjA4Nzc3NDkiIHN0b3AtY29sb3I9IiMzRDNEM0QiLz4KPHN0b3Agb2Zmc2V0PSIwLjg0Mzc1IiBzdG9wLWNvbG9yPSIjMjUyNTI1Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzE0MTQxNCIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgHole as ReactComponent };